<th *ngIf="allowSelection$ | async" class="checkbox-column">
  <lib-checkbox [checked]="isCurrentPageSelected$ | async" (change)="onSelectionChange($event)"></lib-checkbox>
</th>
<ng-content select="th"></ng-content>
